import React from 'react';
import PropTypes from 'prop-types';
import {connectToStores} from 'epic-alt-utils/index';
import {StatsStore} from '../../stores';
import PlayerHeader from '../../components/stats/PlayerHeader';
import PlayerRank from '../../components/stats/PlayerRank';
import PlayerProgress from '../../components/stats/PlayerProgress';

@connectToStores
export default class PlayerCardView extends React.Component {
    static propTypes = {
        statsStore: PropTypes.object //eslint-disable-line
    };
    static getStores() {
        return [StatsStore];
    }

    static getPropsFromStores() {
        return {
            statsStore: StatsStore.getState()
        };
    }

    render() {
        const {playerStats = {}} = this.props.statsStore;
        const {displayName, gameModes, avatar, countryFlag, countryName, xp, level, startLevelBar, endLevelBar, goldStars, blueStars, percentageLevelBar, accountId} = playerStats;
        return (
            <div className="player-card-view">
                <PlayerHeader displayName={displayName} avatar={avatar} countryName={countryName} countryFlag={countryFlag} />
                <PlayerRank gameModes={gameModes} />
                <PlayerProgress
                    level={level}
                    xp={xp}
                    startLevelBar={startLevelBar}
                    percentageLevelBar={percentageLevelBar}
                    endLevelBar={endLevelBar}
                    goldStars={goldStars}
                    blueStars={blueStars}
                    accountId={accountId} />
            </div>
        );
    }
}
